/* FJBC header enhancement. CSS retains the approved layout, announcement animation and
   no-JavaScript checkbox controls. JavaScript adds keyboard navigation and modal focus. */
(function () {
  function measureBar() {
    var bar = document.querySelector('.ann-sec');
    if (!bar) return;
    var set = function () { document.documentElement.style.setProperty('--ann-h', bar.getBoundingClientRect().height + 'px'); };
    set();
    if (window.ResizeObserver) new ResizeObserver(set).observe(bar);
    else window.addEventListener('resize', set);
  }

  function init() {
    var header = document.querySelector('.hdr-rel');
    if (!header || header.dataset.keyboardNav) return;
    measureBar();
    header.dataset.keyboardNav = 'true';
    var desktop = window.matchMedia('(min-width: 1025px)');
    var navLinks = Array.from(header.querySelectorAll('.main-nav a'));
    var pairs = ['jew', 'wed', 'svc'].map(function (key) {
      var trigger = header.querySelector('.dd-' + key);
      var panel = header.querySelector('.dd-panel-' + key);
      panel.id = 'header-dropdown-' + key;
      trigger.setAttribute('aria-controls', panel.id);
      trigger.setAttribute('aria-expanded', 'false');
      return { trigger: trigger, panel: panel, links: Array.from(panel.querySelectorAll('a[href]')) };
    });
    var activePair = null;
    var closeTimer;
    var ignoreFocus = false;
    var overlay = null;

    function pairFor(element) {
      return pairs.find(function (pair) { return pair.trigger.contains(element) || pair.panel.contains(element); });
    }
    function openPair(pair) {
      window.clearTimeout(closeTimer);
      if (!desktop.matches || overlay) pair = null;
      activePair = pair;
      pairs.forEach(function (item) {
        item.panel.classList.toggle('is-open', item === pair);
        // Closing visibility is animated; remove hidden links from keyboard navigation
        // immediately so native Tab cannot re-enter panels after the last nav link.
        item.panel.inert = item !== pair;
        item.trigger.setAttribute('aria-expanded', String(item === pair));
      });
    }
    openPair(null);
    function focusWithoutOpening(element) {
      ignoreFocus = true;
      element.focus();
      ignoreFocus = false;
    }
    pairs.forEach(function (pair) {
      [pair.trigger, pair.panel].forEach(function (element) {
        element.addEventListener('pointerenter', function () { openPair(pair); });
        element.addEventListener('pointerleave', function () {
          closeTimer = window.setTimeout(function () {
            if (pairFor(document.activeElement) !== pair && activePair === pair) openPair(null);
          }, 250);
        });
      });
      pair.panel.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        if (event.shiftKey && document.activeElement === pair.links[0]) {
          event.preventDefault();
          pair.trigger.focus();
        } else if (!event.shiftKey && document.activeElement === pair.links[pair.links.length - 1]) {
          var next = navLinks[navLinks.indexOf(pair.trigger) + 1];
          if (next) { event.preventDefault(); next.focus(); }
        }
      });
    });
    navLinks.forEach(function (link, index) {
      link.addEventListener('keydown', function (event) {
        var pair = pairs.find(function (item) { return item.trigger === link; });
        if (event.key === 'Tab' && event.shiftKey) {
          var previous = pairs.find(function (item) { return item.trigger === navLinks[index - 1]; });
          if (previous) {
            event.preventDefault();
            openPair(previous);
            previous.links[previous.links.length - 1].focus();
          }
        } else if (pair && ((event.key === 'Tab' && !event.shiftKey) || event.key === 'ArrowDown' || event.key === ' ')) {
          event.preventDefault();
          openPair(pair);
          pair.links[0].focus();
        }
      });
    });
    document.addEventListener('focusin', function (event) {
      if (ignoreFocus) return;
      openPair(pairFor(event.target) || null);
    });

    // Replace label controls only after JS loads. The checkboxes remain the CSS state and
    // native labels remain the fallback if JavaScript is unavailable.
    function buttonFrom(selector, toggle) {
      var label = document.querySelector(selector);
      var button = document.createElement('button');
      Array.from(label.attributes).forEach(function (attr) {
        if (attr.name !== 'for') button.setAttribute(attr.name, attr.value);
      });
      button.type = 'button';
      button.classList.add('header-control');
      button.innerHTML = label.innerHTML;
      label.replaceWith(button);
      button.addEventListener('click', function () {
        toggle.checked = !toggle.checked;
        toggle.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return button;
    }
    function focusables(container) {
      return Array.from(container.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,summary,[tabindex="0"]')).filter(function (element) {
        return !element.disabled && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
      });
    }
    // Isolate the open panel from everything behind its scrim, preserving existing inert state.
    function isolate(container) {
      var changed = [];
      for (var node = container; node && node !== document.body; node = node.parentElement) {
        Array.from(node.parentElement.children).forEach(function (sibling) {
          if (sibling !== node && !sibling.inert && !/^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName) && !sibling.matches('.s-scrim,.m-scrim')) {
            sibling.inert = true;
            changed.push(sibling);
          }
        });
      }
      return changed;
    }
    function closeOverlay(restore) {
      if (!overlay) return;
      var previous = overlay;
      overlay = null;
      previous.toggle.checked = false;
      previous.button.setAttribute('aria-expanded', 'false');
      previous.panel.setAttribute('aria-hidden', 'true');
      previous.inert.forEach(function (element) { element.inert = false; });
      if (restore) focusWithoutOpening(previous.button);
    }
    function setupOverlay(toggleId, panelSelector, openSelector, closeSelector, label) {
      var toggle = document.getElementById(toggleId);
      var panel = document.querySelector(panelSelector);
      var button = buttonFrom(openSelector, toggle);
      var closeButton = buttonFrom(closeSelector, toggle);
      toggle.tabIndex = -1;
      toggle.setAttribute('aria-hidden', 'true');
      panel.id = panel.id || toggleId + '-panel';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', label);
      panel.setAttribute('aria-hidden', 'true');
      button.setAttribute('aria-controls', panel.id);
      button.setAttribute('aria-expanded', 'false');
      var item = { toggle: toggle, panel: panel, button: button, closeButton: closeButton, inert: [] };
      document.querySelectorAll('label[for="' + toggleId + '"]').forEach(function (scrim) {
        scrim.addEventListener('click', function (event) {
          event.preventDefault();
          if (overlay === item) closeOverlay(true);
        });
      });
      toggle.addEventListener('change', function () {
        if (!toggle.checked) {
          if (overlay === item) closeOverlay(true);
          return;
        }
        closeOverlay(false);
        openPair(null);
        overlay = item;
        toggle.checked = true;
        button.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        item.inert = isolate(panel);
        var first = panel.querySelector('input[name="q"]') || closeButton;
        first.focus();
      });
      return item;
    }
    var search = setupOverlay('s-tog', '.s-bar', '.s-btn', '.s-close', 'Search');
    var menu = setupOverlay('m-nav', '.m-drawer', '.m-nav-btn', '.m-close', 'Menu');
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (overlay) { event.preventDefault(); closeOverlay(true); }
        else if (activePair) {
          event.preventDefault();
          var trigger = activePair.trigger;
          openPair(null);
          focusWithoutOpening(trigger);
        }
      } else if (event.key === 'Tab' && overlay) {
        var items = focusables(overlay.panel);
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    });
    desktop.addEventListener('change', function () {
      openPair(null);
      if (desktop.matches && overlay === menu) {
        closeOverlay(false);
        focusWithoutOpening(header.querySelector('.logo-lockup'));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
